import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
import axiosInstance from './axiosConfig';

/**
 * Fetches monthly spending data directly from the API for the last 3 months
 * @returns {Promise<Object>} Object with amounts and labels arrays
 */
export const fetchMonthlySpendingData = async () => {
  try {
    const today = new Date();
    const amounts = [];
    const labels = [];
    
    // Fetch last 3 months of data
    for (let i = 2; i >= 0; i--) {
      const monthStart = startOfMonth(subMonths(today, i));
      const monthEnd = endOfMonth(subMonths(today, i));
      
      const response = await axiosInstance.get('/transactions', {
        params: {
          startDate: monthStart.toISOString(),
          endDate: monthEnd.toISOString(),
          limit: 1000,
          sortBy: 'date',
          sortDirection: 'desc'
        }
      });

      // Calculate total amount for the month
      const monthlyTotal = response.data.transactions.reduce((sum, t) => sum + t.amount, 0);
      amounts.push(monthlyTotal);
      
      // Format month label (e.g., "Mar 2024")
      labels.push(monthStart.toLocaleString('en-US', { month: 'short', year: 'numeric' }));
    }

    return {
      amounts,
      labels
    };
  } catch (error) {
    console.error('Error fetching monthly spending data:', error);
    return {
      amounts: [],
      labels: []
    };
  }
}; 